import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { CashIsleLogo } from "@/components/CashIsleLogo";
import { Compass } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.warn("404:", location.pathname);
  }, [location.pathname]);

  return (
    <main className="min-h-screen bg-wave-gradient text-primary-foreground grid place-items-center px-6">
      <Helmet>
        <title>Page not found — Cash Isle</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="text-center max-w-sm">
        <div className="mx-auto mb-6">
          <CashIsleLogo size={48} />
        </div>
        <p className="text-xs uppercase tracking-[0.3em] opacity-70 mb-2">404</p>
        <h1 className="font-display font-extrabold text-3xl mb-2">Lost at sea</h1>
        <p className="text-sm opacity-80 mb-6">
          We couldn't find <span className="font-mono">{location.pathname}</span>. Let's get you back to dry land.
        </p>
        <div className="flex gap-3 justify-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-2xl bg-accent text-accent-foreground font-semibold text-sm"
          >
            <Compass className="h-4 w-4" />
            Home
          </Link>
          <Link
            to="/wallet"
            className="inline-flex items-center px-5 py-2.5 rounded-2xl bg-primary-foreground/10 backdrop-blur border border-primary-foreground/20 font-semibold text-sm"
          >
            My wallet
          </Link>
        </div>
      </div>
    </main>
  );
};

export default NotFound;
